import { render, staticRenderFns } from "./accommodation-modal.vue?vue&type=template&id=7064622f"
import script from "./accommodation-modal.vue?vue&type=script&lang=js"
export * from "./accommodation-modal.vue?vue&type=script&lang=js"
import style0 from "./accommodation-modal.vue?vue&type=style&index=0&id=7064622f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports